import { Reveal, Overline } from "./Primitives";
import { SERVICE_AREAS, IMAGES } from "@/data/content";
import { MapPin } from "lucide-react";

export const ServiceAreas = () => (
  <section id="areas" className="relative py-20 md:py-32 overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img src={IMAGES.skyline} alt="New York City skyline" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#050505]/85" />
    </div>

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 text-center">
      <Reveal>
        <Overline className="mb-4">Service Areas</Overline>
        <h2 className="font-display font-light tracking-tight text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
          Serving Queens, Brooklyn, Manhattan <span className="gold-gradient italic">Long Island &amp; Nassau County</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap justify-center gap-4">
          {SERVICE_AREAS.map((a) => (
            <div
              key={a}
              data-testid={`area-${a.toLowerCase().replace(/\s/g, "-")}`}
              className="flex items-center gap-2 border border-gold/30 bg-black/40 backdrop-blur-sm px-6 py-3 hover:border-gold transition-colors duration-300"
            >
              <MapPin size={16} className="text-gold" />
              <span className="text-sm md:text-base text-white">{a}</span>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.25}>
        <p className="mt-10 max-w-2xl mx-auto text-sm text-zinc-400 leading-relaxed">
          Selected locations and service availability may vary by service type and scheduling. Selected
          surrounding areas may be available depending on distance, service type and scheduling.
        </p>
      </Reveal>
    </div>
  </section>
);
